import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import MyMentor from "./coaching/MyMentor";
import CoachingSuggestions from "./coaching/CoachingSuggestions";
import CoachingFeedback from "./coaching/CoachingFeedback";
import FindMentor from "./coaching/FindMentor";
import CoachingTabs from "./coaching/CoachingTabs";

const TAB_COMPONENTS = {
	coach: MyMentor,
	suggestions: CoachingSuggestions,
	feedback: CoachingFeedback,
	find: FindMentor,
};

export default function MyCoaching() {
	const [searchParams] = useSearchParams();
	const requestedTab = searchParams.get("tab") || "coach";
	const ActiveComponent = useMemo(
		() => TAB_COMPONENTS[requestedTab] || MyMentor,
		[requestedTab]
	);

	return (
		<>
			{/* Desktop: tabs sit on top. Mobile: each tab renders CoachingTabs below its page header. */}
			<CoachingTabs className="hidden md:block max-w-5xl mx-auto px-4 mb-6" />
			<ActiveComponent />
		</>
	);
}
